<template>
  <div class="project-listing" id="project__list">
	<b-modal v-model="showRemoveProjectDeli" type="warn" title="Remove Options">
		<p>Please choose one of the following actions below to remove the deliverable.</p>
		<template #modal-footer>
			<button @click="showRemoveProjectDeli=false" type="button" class="btn btn-secondary">Cancel</button>
			<button @click="deleteDeliverable()" type="button" class="btn btn-danger">Delete Deliverable</button>
			<button @click="onConfirmRemoveProjectDeli" type="button" class="btn btn-primary">Remove just from this Project</button>
		</template>
	</b-modal>
	<CreateCfContactModal v-show="currentFieldKey!=''" ref="refCfContactModal" :namespace="namespace" />
	<UpdateCfContactModal v-show="currentFieldKey!=''" ref="refUpdateCfContactModal" :namespace="namespace" />
      <div class="project__list">

		<EditProjectModal :projectDeliverables="projectDeliverables" ref="refEditProjectModal"/>

		<b-card no-body class="project--bottom-section" id="projectBottomCard">
			<b-tabs v-model="activeProjectTab" card  content-class="add-project-deliverable-tab">
				<b-tab title="Project deliverables" class="project--deliverable--tab-content">
					<b-card-text>
						<ProjectDeliverableComponent :namespace="namespace"/>
					</b-card-text>
				</b-tab>
				<b-tab title="Project calendar" lazy>
					<ProjectCalendar ref="projectCalendarTab" :namespace="namespace"/>
				</b-tab>
			</b-tabs>
		</b-card>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ProjectCustomFields from "../common/ProjectCustomField";
import EditProjectModal from "./EditProjectModal"
import ProjectDatesRibbon from "./ProjectDatesRibbon";
import vueStarRate from "vue-js-star-rating";
import ProjectDepartments from "./ProjectDepartments";
import EditModal from "./EditModal";
import TaskFields from "./TaskFields";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import CreateCfContactModal from "./CreateCfContactModal";
import UpdateCfContactModal from "./EditCfContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DuplicateMediaCallFromProjectBtn from "../common/DuplicateMediaCallFromProjectBtn";

import ProjectDeliverableComponent from '@/csmworkflow/js/views/ProjectDeliverableComponent';
import AddProjectDeliverable from '@/csmworkflow/js/views/AddProjectDeliverable';

import UpdateWhoModal from "./EditWhoModal";
import ProjectCalendar from "./ProjectCalendar";
import CreateWhoModal from "./CreateWhoModal";


import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableType from "./DeliverableType";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import toast from '../../toast';

export default {
	data() {
		return {
			namespace:"",
			removedDeliverableId: false,
			activeProjectTab: 0,
			filterQuery: {
				query: "",
				filterByDate: false,
				filterByDateCreated: false,
				filterByDateCompleted: false,
				dateRange: {
				startDate: new Date(),
				endDate: new Date()
				},
				dateCreatedRange: {
				startDate: new Date(),
				endDate: new Date()
				},
				dateCompletedRange: {
				startDate: new Date(),
				endDate: new Date()
				},
				status: [],
				outlet: [],
				deliverableType: [],
				tag: [],
				department: [],
				coordinator: []
			},
			expandAll: true,
			removingDeliverableId: false,
			showRemoveProjectDeli: false,
			currentProjectTitle: 'Project'

		}
	},

	components: {
		ProjectCustomFields,
		ProjectCalendar,
		AddProjectDeliverable,
		ProjectDeliverableComponent,
		EditProjectModal,
		ProjectDatesRibbon,
		vueStarRate,
		ProjectDepartments,
		EditModal,
		TaskFields,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		CreateCfContactModal,
		UpdateCfContactModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallFromProjectBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		DeliverableTypeIcon,
		DeliverableProjects,
		DeliverableType
	},
	computed: {
		...mapGetters([
			"systemSettings",
			"getSystemSetting",
			"currentFieldKey",
		]),
		...mapState({
		  state (state) {
		    return state[this.namespace]
		  },
		  projects (state, getters) {
		    return getters[this.namespace + 'projects']
		  },
		  projectDeliverables (state, getters) {
		    return getters[this.namespace + 'projectDeliverables']
		  },
		  allProjectDeliverablesPaginationData (state, getters) {
		    return getters[this.namespace + 'allProjectDeliverablesPaginationData']
		  },
		  projectDetail (state, getters) {
		    return getters[this.namespace + 'projectDetail']
		  },
		  deliverableDetail (state, getters) {
		    return getters[this.namespace + 'deliverableDetail']
		  },
		  allContacts (state, getters) {
		    return getters[this.namespace + 'allContacts']
		  },
		  userAbilities (state, getters) {
		    return getters['userAbilities']
		  },
		  deliverableTypes (state, getters) {
		    return getters[this.namespace + 'deliverableTypes']
		  },
		  	getDeliverableTemplateSlug(state, getters) {
				return getters[this.namespace + "getDeliverableTemplateSlug"];
			},
		}),
		_() {
			return _;
		}
	},
	created() {
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchSystemSettings();
		this.fetchGeoData();
	},
	methods: {
		...mapActions({
		  fetchProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchProjects', payload)
		  },
		  fetchDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDepartments', payload)
		  },
		  fetchActiveDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveDepartments', payload)
		  },
		  updateFieldValue (dispatch, payload) {
		    return dispatch(this.namespace + 'updateFieldValue', payload)
		  },
		  fetchUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUsers', payload)
		  },
		  fetchActiveUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveUsers', payload)
		  },
			fetchSystemSettings(dispatch, payload) {
				return dispatch("fetchSystemSettings", payload)
			},
			fetchGeoData(dispatch, payload) {
				return dispatch(this.namespace + 'fetchGeoData', payload)
			},
		}),
		checkDuplicationStatus() {
			if (!this.projectDetail || !this.projectDetail.id) return;
			
			axios.get(`/api/v1/checkProjectDuplicationStatus/${this.projectDetail.id}`)
				.then(response => {
					if (response.data.is_duplicating) {
						this.$store.dispatch('showDuplicationWarning', {
							message: response.data.message,
							startedBy: response.data.started_by,
							progress: response.data.progress,
							jobKey: response.data.job_key,
							startedAt: response.data.started_at,
							context: response.data.context,
							jobMessage: response.data.job_message
						});
					} else {
						this.$store.dispatch('hideDuplicationWarning');
					}
				})
				.catch(error => {
					console.error('Error checking duplication status:', error);
				});
		},
		deleteDeliverable() {
			if (this.removingDeliverableId) {
				let that = this;
				let deliverableId = this.removingDeliverableId;
				this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId:deliverableId }).then(function(response) {
					that.showRemoveProjectDeli=false
					if (response && response?.status && response?.status != 200) {
						return;
					}
					toast.hide();
					const deliverableTemplateSlug = that.getDeliverableTemplateSlug(parseInt(that.deliverableDetail.deliverable_template_id));
					if (deliverableTemplateSlug == "media-call") {
						that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Media call deleted.');
					} else {
						that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');
		            }
					that.$store.dispatch(that.namespace + 'fetchProjectDeliverable');
					that.$store.dispatch(that.namespace + "removeProjectDeliverable", { projectId: that.projectDetail.id, deliverableId: that.removingDeliverableId })
				});
			}
		},

		onConfirmRemoveProjectDeli() {
			let that = this;
			if(this.removingDeliverableId) {
				this.$store
					.dispatch(this.namespace + "removeProjectDeliverable", { projectId: this.projectDetail.id, deliverableId: this.removingDeliverableId })
					.then(() => {
						that.showRemoveProjectDeli=false
						that.removedDeliverableId = that.removingDeliverableId
						that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable removed from project.');
						that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function(response) {
						});
					});
			}
		},
		editDeliverableModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		setPriority(deliverable) {
			let priority = $('.listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			let priorityData = {
				field_id: 23,
				parentId: null,
				value: priority,
				deliverable_id: deliverable.id,
				id: deliverable.id
			};
			this.updateFieldValue(priorityData);
		},
		editProjectModalHidden() {
			this.$store.commit(this.namespace + 'setProject', this.projectDetail)
		},
		focusContactModal() {
			this.$refs.refContactModal.focusMyElement();
		},
		focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
		focusSpokespersonModal() {
			this.$refs.refSpokespersonModal.focusMyElement();
		},
		focusUpdateSpokespersonModal() {
			this.$refs.refUpdateSpokespersonModal.focusMyElement();
		},
		focusWhoModal() {
			this.$refs.refWhoModal.focusMyElement();
		},
		focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
		onChangePage(data) {
			this.fetchProjects(data);
		},
		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('project/') == -1) {
				history.pushState(
					{},
					null,
					'project/' + encodeURIComponent(this.projectDetail.id) + '/' + encodeURIComponent(this.projectDetail.slug)
				)
			}
		},
		showModalFn(deliverableId) {
			// shows edit deliverable modal
			let that = this;
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editDeliverableModal");
				});
		},

		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
			}
		}
	},
	mounted() {
		if(typeof this.$route.query.activeTab != 'undefined') {
			this.activeProjectTab = parseInt(this.$route.query.activeTab)
		}
		let that = this;
		if (!this.projectDetail || !this.projectDetail.id || this.projectDetail.id != this.$router.currentRoute.params.projectId) {
			this.$store.commit(this.namespace + "setDataLoading", true);
			const page = Number(this.$route.query.page) || 1;
			this.$store.dispatch(this.namespace + 'fetchProjectDeliverable', page).then(() => {
				this.$store.commit(this.namespace + "setDataLoading", false);
				// Check duplication status after project loads
				that.checkDuplicationStatus();
			});
		} else {
			// Check duplication status on refresh
			this.checkDuplicationStatus();
		}
		if(typeof this.$route.query.activeTab != 'undefined' && this.$route.query.activeTab == '0') {
			this.$nextTick(() => {
				var cardEl = $('#projectBottomCard')[0];
				window.scrollTo(0, cardEl.offsetTop);
			});
		} else {
			this.$nextTick(() => {
				window.scrollTo(0, 0);
			})
		}
		this.$root.$on('showRemoveDeliverableFromProjModal', (deliverableId) => {
			that.removingDeliverableId = deliverableId
			that.showRemoveProjectDeli = true
		})
		this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editProjectModal") {
				that.$store.state.deliverables.editProjectModal = false;
			}
		});
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editProjectModal") {
				this.$store.state.deliverables.editProjectModal = true;
			}
		});
	},
	watch: {
		activeProjectTab: function() {
			if (this.activeProjectTab == 1) {
				this.$nextTick(() => {
					this.$refs['projectCalendarTab'].$refs['csm__project__calendar'].getApi().updateSize();
				})
			}
		}
	},
	beforeDestroy() {
		// Hide the duplication overlay when leaving the page
		this.$store.dispatch('hideDuplicationWarning');
	}
}
</script>

<style>

</style>
